import { useEffect, useRef } from 'react';
import { useRequestData } from 'wsm-common-data';
import logger from 'ws-scripts/modules/logger';
import { LocationsData } from '../data/LocationsData';
import { requestLocations } from '../utilities/locationFetch';
import { useAccountId } from '../features/accountId/accountIdSlice';
import { useDealerPhotoBaseUrl } from '../features/dealerPhoto/dealerPhotoSlice';
import { getDDCLocationsData } from '../utilities/ddcHelper';

const LOG_PREFIX = '[ws-locations-data][Widget]';
const LOCATIONS_DATA_READY_EVENT = 'DDC:LocationsDataReady';

const Widget = () => {
	const accountId = useAccountId();
	const { locale } = useRequestData();
	const isFirstLoadRef = useRef(true);
	const dealerPhotoBaseUrl = useDealerPhotoBaseUrl();

	useEffect(() => {
		if (!getDDCLocationsData()) {
			// Create global namespace
			window.DDC = window.DDC || {};

			// Create LocationsData instance with request handler
			window.DDC.LocationsData = new LocationsData(
				(params) => {
					const {
						postalCode,
						range,
						excludeByRange,
						useDefaultTileCount,
						isDefaultView
					} = params;
					// Only use defaultTileCount on first load
					const isDefaultTileCountNeeded =
						useDefaultTileCount && isFirstLoadRef.current;
					isFirstLoadRef.current = false;

					logger.debug(`${LOG_PREFIX} Triggering location request:`, {
						postalCode,
						range,
						excludeByRange,
						accountId,
						locale,
						isDefaultTileCountNeeded
					});

					return requestLocations({
						postalCode,
						range,
						excludeByRange,
						accountId,
						locale,
						isDefaultTileCountNeeded,
						isDefaultView
					});
				},
				{ dealerPhotoBaseUrl }
			);

			/**
			 * Dispatch ready event for consuming widgets.
			 * Consumers (ws-locations-search, ws-locations-control) listen for this event
			 * to know when LocationsData is available.
			 * @event DDC:LocationsDataReady
			 */
			logger.debug(`${LOG_PREFIX} Dispatching LocationsDataReady event`);
			window.dispatchEvent(new CustomEvent(LOCATIONS_DATA_READY_EVENT));
		}
	}, [accountId, locale]);

	return null;
};

export default Widget;
